import React, { useMemo, useState, useEffect, useRef } from "react";
import "./FlightSearchResult.css";
import { useLocation } from "react-router-dom";
import FlightSearch from "../FlightSearch.jsx";
import FlightCard from "./FlightCard.jsx";
import Navber from "../../../Components/Navber.jsx";
import axios from "axios";
import { useNavigate } from "react-router-dom";


const formatDate = date =>
  new Date(date).toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric"
  });

export default function FlightSearchResult() {
  const location = useLocation();
  const results = location?.state?.results;
  const searchData = location.state?.searchData
  const [calendarFare, setCalendarFare] = useState([]);
  const [selectedDate, setSelectedDate] = useState(null);
  const [calender,setCalender] = useState(false);
  const navigate = useNavigate();

  const [calLoading, setCalLoading] = useState(false);


  console.log("before .....", results);

  // API RESULT ARRAY
  const cardData =
    results?.data?.responseData?.Response?.Results?.["0"] || results?.responseData?.Response?.Results?.["0"] || [];
  const origins = results?.data?.responseData?.Response?.Origin
  const destinations = results?.data?.responseData?.Response?.Destination
  console.log("the total card data is ", cardData)
  const segment = cardData[0]?.Segments?.[0]?.[0]
  console.log(" the segment is :", segment)
  const traceId = results?.data?.responseData?.Response?.TraceId || results?.responseData?.Response?.TraceId
  /* ---------------- FILTER STATES ---------------- */
  const [filters, setFilters] = useState({
    stops: [],                 // ["direct","1stop"]
    price: [0, 100000],         // min, max
    depTime: [],               // morning / afternoon / evening / night
    arrTime: [],
    duration: 10000,            // max minutes
    refundable: null,          // true | false | null
    fareTypes: [],             // Saver, Corporate, Flexi...
    airlines: []               // 6E, AI, SG...
  });


  const [expandedCard, setExpandedCard] = useState(null);
  const getTimeSlot = (dateStr) => {
    const hour = new Date(dateStr).getHours();
    if (hour < 6) return "night";
    if (hour < 12) return "morning";
    if (hour < 18) return "afternoon";
    return "evening";
  };


  /* ---------------- FILTER LOGIC ---------------- */

console.log("before filtering: ", cardData);

const filteredData = useMemo(() => {
  if (!cardData) return [];

  const dataArray = Object.values(cardData);

  return dataArray.filter((item) => {
    const seg = item?.Segments?.[0]?.[0];
    if (!seg) return false;

    const stops =
      item?.Segments?.[0]?.length > 1 ? "1stop" : "direct";

    const depSlot = getTimeSlot(seg?.Origin?.DepTime);
    const arrSlot = getTimeSlot(seg?.Destination?.ArrTime);

    const duration = seg?.Duration || 0;
    const price = item?.Fare?.PublishedFare || 0;

    // Stops
    if (
      filters.stops.length &&
      !filters.stops.includes(stops)
    )
      return false;

    // Price
    if (
      price < filters.price[0] ||
      price > filters.price[1]
    )
      return false;

    // Departure Time
    if (
      filters.depTime.length &&
      !filters.depTime.includes(depSlot)
    )
      return false;

    // Arrival Time
    if (
      filters.arrTime.length &&
      !filters.arrTime.includes(arrSlot)
    )
      return false;

    // Duration
    if (duration > filters.duration) return false;

    // Refundable
    if (
      filters.refundable !== null &&
      item?.IsRefundable !== filters.refundable
    )
      return false;

    // Fare Family
    if (
      filters.fareTypes.length &&
      !filters.fareTypes.includes(item?.ResultFareType)
    )
      return false;

    // Airlines
    if (
      filters.airlines.length &&
      !filters.airlines.includes(
        seg?.Airline?.AirlineCode
      )
    )
      return false;

    return true;
  });
}, [
  cardData,
  filters.stops,
  filters.price,
  filters.depTime,
  filters.arrTime,
  filters.duration,
  filters.refundable,
  filters.fareTypes,
  filters.airlines,
]);

  console.log("after filtering: ", filteredData);


  const toggleExpand = (index) => {
    setExpandedCard(expandedCard === index ? null : index);
  };

  const CARDS_PER_LOAD = 50;
  const [visibleCount, setVisibleCount] = useState(CARDS_PER_LOAD);
  const displayData =
    filteredData.length > 0 ? filteredData : cardData;

  const visibleData = displayData.slice(0, visibleCount);

const fetchCalendarFare = async (date) => {
  try {
    setCalLoading(true);

    const res = await axios.post(
      "https://admin.jayrajgroup.com/api/flights/calendar-fare",
      {
        From_IATACODE: searchData?.fromCode,
        To_IATACODE: searchData?.toCode,
        departure_date: date, // any date of the month
        Flights_category: searchData?.travelClass || "Economy",
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          Accept: "application/json",
        },
      }
    );

    // ✅ CORRECT KEY
    const results =
      res.data?.responseData?.Response?.SearchResults || [];

    setCalendarFare(results);
  } catch (err) {
    console.error("Calendar fare error", err);
  } finally {
    setCalLoading(false);
  }
};


const normalizeCalendarFare = useMemo(() => {
  const map = {};

  calendarFare.forEach(item => {
    const date = item.DepartureDate.split("T")[0];

    if (!map[date] || item.Fare < map[date].fare) {
      map[date] = {
        date,
        fare: item.Fare,
        airline: item.AirlineCode,
        isCheapest: item.IsLowestFareOfMonth,
      };
    }
  });

  return Object.values(map);
}, [calendarFare]);

const calendarRef = useRef(null);

const scrollCalendar = (direction) => {
  if (!calendarRef.current) return;

  const scrollAmount = 300; // pixels
  calendarRef.current.scrollBy({
    left: direction === "left" ? -scrollAmount : scrollAmount,
    behavior: "smooth",
  });
};




useEffect(() => {
  if (!searchData?.departureDate) return;

  setSelectedDate(searchData.departureDate);
  fetchCalendarFare(searchData.departureDate);
  setCalender(true);
}, [searchData?.departureDate]);




const handleCalendarDateSelect = (date) => {
  // if (date === selectedDate) return;

  setSelectedDate(date);

  const updatedSearchData = {
    ...searchData,
    departureDate: date,
  };

  // 🔥 Trigger FlightSearch auto-search
  navigate("/flight-search-result", {
    replace: true,
    state: {
      results, // keep old results till new comes
      searchData: updatedSearchData,
      fromCalendar: true, // 👈 flag
    },
  });
};








  return (
    <>
      <Navber />
     <FlightSearch
  initialData={searchData}
  calender={location.state?.fromCalendar}
/>

      <div className="fsr-page">

        {/* ================= LEFT FILTER PANEL ================= */}
        <aside className="fsr-filter">
          <span style={{ display: "flex", justifyContent: "space-between" }}>
            <span style={{ fontWeight: "600", fontSize: "1.3rem", textDecoration: "underline", color: "gold" }}>Filters</span>
            <button
              className="reset-btn"
              onClick={() =>
                setFilters({
                  stops: [],
                  price: [0, 20000],
                  depTime: [],
                  arrTime: [],
                  duration: 1000,
                  refundable: null,
                  fareTypes: [],
                  airlines: []
                })
              }
            >
              Reset All
            </button>
          </span>

          {/* STOPS */}
          <div className="filter-block">
            <h4>Number of Stops</h4>
            <label>
              <input
                type="checkbox"
                onChange={(e) =>
                  setFilters(f => ({
                    ...f,
                    stops: e.target.checked
                      ? [...f.stops, "direct"]
                      : f.stops.filter(s => s !== "direct")
                  }))
                }
              />
              Direct
            </label>
            <label>
              <input
                type="checkbox"
                onChange={(e) =>
                  setFilters(f => ({
                    ...f,
                    stops: e.target.checked
                      ? [...f.stops, "1stop"]
                      : f.stops.filter(s => s !== "1stop")
                  }))
                }
              />
              1 Stop
            </label>
          </div>

          {/* PRICE */}
          <div className="filter-block">
            <h4>Price (₹)</h4>
            <input
              type="range"
              min="0"
              max="100000"
              step="500"
              value={filters.price[1]}
              onChange={(e) =>
                setFilters(f => ({ ...f, price: [0, +e.target.value] }))
              }
            />
            <span>Up to ₹{filters.price[1]}</span>
          </div>

          {/* DEPARTURE TIME */}
          <div className="filter-block">
            <h4>Departure Time</h4>
            {["morning", "afternoon", "evening", "night"].map(t => (
              <label key={t}>
                <input
                  type="checkbox"
                  onChange={(e) =>
                    setFilters(f => ({
                      ...f,
                      depTime: e.target.checked
                        ? [...f.depTime, t]
                        : f.depTime.filter(x => x !== t)
                    }))
                  }
                />
                {t}
              </label>
            ))}
          </div>

          {/* ARRIVAL TIME */}
          <div className="filter-block">
            <h4>Arrival Time</h4>
            {["morning", "afternoon", "evening", "night"].map(t => (
              <label key={t}>
                <input
                  type="checkbox"
                  onChange={(e) =>
                    setFilters(f => ({
                      ...f,
                      arrTime: e.target.checked
                        ? [...f.arrTime, t]
                        : f.arrTime.filter(x => x !== t)
                    }))
                  }
                />
                {t}
              </label>
            ))}
          </div>

          {/* DURATION */}
          <div className="filter-block">
            <h4>Fly Duration</h4>
            <input
              type="range"
              min="60"
              max="10000"
              step="30"
              value={filters.duration}
              onChange={(e) =>
                setFilters(f => ({ ...f, duration: +e.target.value }))
              }
            />
            <span>Up to {filters.duration} mins</span>
          </div>

          {/* FARE TYPE */}
          <div className="filter-block">
            <h4>Fare Type</h4>
            <label>
              <input type="radio" name="fare"
                onChange={() => setFilters(f => ({ ...f, refundable: true }))} />
              Refundable
            </label>
            <label>
              <input type="radio" name="fare"
                onChange={() => setFilters(f => ({ ...f, refundable: false }))} />
              Non-Refundable
            </label>
          </div>

          {/* AIRLINES */}
          <div className="filter-block">
            <h4>Airlines</h4>
            {[
              // Indian Airlines
              "6E", // IndiGo
              "AI", // Air India
              "QP", // Akasa Air
              "SG", // SpiceJet
              "IX", // Air India Express
              "UK", // Vistara
              "G8", // Go First
              "S5", // Star Air
              "I5", // AirAsia India

              // International Airlines
              // "AA", // American Airlines
              // "DL", // Delta Airlines
              // "UA", // United Airlines
              // "AC", // Air Canada
              // "BA", // British Airways
              // "LH", // Lufthansa
              // "AF", // Air France
              // "KL", // KLM
              // "EK", // Emirates
              // "QR", // Qatar Airways
              // "EY", // Etihad
              // "SQ", // Singapore Airlines
              // "CX", // Cathay Pacific
              // "JL", // Japan Airlines
              // "NH", // ANA
              // "TK", // Turkish Airlines
              // "AZ", // ITA Airways
              // "SU", // Aeroflot
              // "IB", // Iberia
              // "WY", // Oman Air
              // "GF", // Gulf Air
              // "SV", // Saudia
              // "MH", // Malaysia Airlines
              // "TG", // Thai Airways
              // "VN", // Vietnam Airlines
              // "KE", // Korean Air
              // "OZ"  // Asiana Airlines
            ].map(code => (
              <label key={code}>
                <input
                  type="checkbox"
                  onChange={(e) =>
                    setFilters(f => ({
                      ...f,
                      airlines: e.target.checked
                        ? [...f.airlines, code]
                        : f.airlines.filter(a => a !== code)
                    }))
                  }
                />
                {code}
              </label>
            ))}
          </div>
        </aside>






        {/* ================= RIGHT RESULTS ================= */}
        <main className="fsr-results">

          {/* ================= CALENDAR FARE STRIP ================= */}
{normalizeCalendarFare.length > 0 && (
  <div className="calendar-wrapper">
    
    {/* LEFT ARROW */}
    <button
      className="calendar-arrow left"
      onClick={() => scrollCalendar("left")}
    >
      ‹
    </button>

    {/* CALENDAR STRIP */}
    <div className="calendar-fare-strip" ref={calendarRef}>
      {normalizeCalendarFare.map(item => (
        <div
          key={item.date}
          className={`fare-day
            ${item.date === selectedDate ? "selected" : ""}
            ${item.isCheapest ? "cheapest" : ""}
          `}
          onClick={() => handleCalendarDateSelect(item.date)}

        >
          <div className="fare-date">
            {new Date(item.date).toLocaleDateString("en-GB", {
              day: "2-digit",
              month: "short",
            })}
          </div>

          <div className="fare-price">₹{item.fare}</div>
          <div className="fare-airline">{item.airline}</div>

          {item.isCheapest && (
            <span className="cheap-tag">Lowest</span>
          )}
        </div>
      ))}
    </div>

    {/* RIGHT ARROW */}
    <button
      className="calendar-arrow right"
      onClick={() => scrollCalendar("right")}
    >
      ›
    </button>
  </div>
)}







          <div style={{ color: "white", fontWeight: "600" }}>{filteredData?.length || cardData?.length} Flights found - {origins} to {destinations} | {formatDate(segment?.Origin?.DepTime)}</div>
          {visibleData.map((item, index) => (
            <FlightCard
              key={item?.ResultIndex || index}
              item={item}
              index={index}
              expandedCard={expandedCard}
              toggleExpand={toggleExpand}
              traceId={traceId}
            />
          ))}


          {visibleCount < displayData.length && (
            <div style={{ textAlign: "center", margin: "20px 0" }}>
              <button
                className="show-more-btn"
                onClick={() => setVisibleCount(v => v + CARDS_PER_LOAD)}
              >
                Show More Flights
              </button>
            </div>
          )}



          {filteredData.length === 0 && (
            <p className="no-result">No flights match your filters</p>
          )}
        </main>
      </div>
    </>

  );
}
